<template>
  <div class="text-size-12 show-details">
    <div
    v-if="collapsable"
      @click="whenClickOnText()"
      class="toggle-details text-size-14 text-primary text-weight-semi-bold py-2"
      :class="customClass"
    >
      {{ getHeadingText }} 

                <font-awesome-icon
            v-if="isVisible"
            class="mr-1 ml-1"
            :icon="['fal', 'chevron-up']"
          />
          <font-awesome-icon
            v-else
            class="mr-1 ml-1"
            :icon="['fal', 'chevron-down']"
          />

    </div>
    <p v-if="isVisible || !collapsable" v-html="details"></p>
  </div>
</template>
<script>
export default {
  name: 'ShowDetails',
  props: ['details', 'collapsable', 'headerText', 'customClass'],
  data() {
    return {
      isVisible: false,
    };
  },

  computed: {
    getHeadingText() {
      if (this.headerText) {
        return this.headerText;
      }
      return this.$t('invite.usingEmail');
    },
  },
  methods: {
    whenClickOnText() {
      this.isVisible = !this.isVisible;
      this.$emit('change', this.isVisible);
    }
  }
};
</script>
<style lang="scss" scoped>
.toggle-details {
  cursor: pointer;
}

ul {
  margin-bottom: 1px !important;
}
</style>
